import { useState } from 'react';
import { testimonials } from '@/mocks/comics';

export default function TestimonialSection() {
  const [active, setActive] = useState(0);
  const t = testimonials[active];

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-5xl mx-auto px-4 md:px-8 lg:px-12">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-2">读者口碑</h2>
          <p className="text-foreground-500 text-sm">来自漫迷们的真实评价</p>
        </div>

        <div className="relative bg-foreground-950 rounded-2xl overflow-hidden">
          <div className="flex flex-col md:flex-row">
            <div className="md:w-2/5 relative">
              <img
                src={t.avatar}
                alt={t.name}
                className="w-full h-64 md:h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-transparent to-foreground-950 md:block hidden"></div>
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950 to-transparent md:hidden"></div>
            </div>

            <div className="md:w-3/5 p-8 md:p-10 flex flex-col justify-center">
              <i className="ri-double-quotes-l text-4xl text-primary-400 mb-4"></i>
              <p className="text-background-50 text-base md:text-lg leading-relaxed mb-6">
                {t.content}
              </p>
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-background-50 font-medium text-sm">{t.name}</p>
                  <p className="text-foreground-400 text-xs">{t.level}</p>
                </div>
                <div className="flex gap-2">
                  {testimonials.map((_, i) => (
                    <button
                      key={i}
                      onClick={() => setActive(i)}
                      className={`w-2.5 h-2.5 rounded-full transition-colors cursor-pointer ${i === active ? 'bg-primary-500' : 'bg-foreground-600 hover:bg-foreground-500'}`}
                      aria-label={`查看第${i + 1}条评价`}
                    ></button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}